export enum TipoBuscaEnum {
  Conta = 0,
  TipoLancamento = 1,
  RelatorioCaixa = 2,
  CategoriaRelatorio = 3,
}

export interface OpcaoTipoBusca {
  label: string;
  value: TipoBuscaEnum;
}

export const OPCOES_TIPO_BUSCA: OpcaoTipoBusca[] = [
  { label: 'Por Conta', value: TipoBuscaEnum.Conta },
  { label: 'Por Tipo de Lançamento', value: TipoBuscaEnum.TipoLancamento },
  { label: 'Por Relatório', value: TipoBuscaEnum.RelatorioCaixa },
  { label: 'Por Categoria do Relatório', value: TipoBuscaEnum.CategoriaRelatorio },
];
